import { RouterLink } from "../../../../../../../components/router-link";

interface Props {
  userId: string;
  label: string;
}

export const UserDetailLinkCell = ({ userId, label }: Props) => {
  return (
    <RouterLink params={{ userId }} to={"/app/users/$userId"} underline="hover">
      {label}
    </RouterLink>
  );
};
